import React, { Component } from 'react'
import { browserHistory } from 'react-router'
import Create from '../crud/create'
import menuItems from './menuItems'
import api from '../../api'
import omit from 'lodash/omit'

const fields = [
  {
    name: 'Week',
    prop: 'week_id',
    type: 'autocomplete',
    references: 'admin/weeks',
    referenceProp: 'long_name',
    query: {
      filters: {
        without_homeworks: true
      }
    }
  }
]

class CopyHomework extends Component<any, any> {
  componentWillMount () {
    this.getResource()
  }

  constructor (props) {
    super(props)
    this.state = {
      resource: null
    }
  }

  getResource () {
    const path = `admin/homeworks/${this.props.params.homeworkId}?with_deleted=true`

    return api
      .get(path)
      .then(res => {
        if (res.status === 200) {
          res.json().then(resource => {
            this.setState({ resource: omit(resource, 'id') })
          })
        } else {
          browserHistory.push('/write-now/homework')
        }
      })
  }

  render () {
    return (
      <Create
// @ts-ignore
        title='Copying Homework'
        fields={fields}
        apiPath={`admin/homeworks/${this.props.params.homeworkId}/copy`}
        successRedirectPath='/write-now/homework'
        buildMenuItems={menuItems}
        resource={this.state.resource}
      />
    )
  }
}

export default CopyHomework
